export enum FileIds {
    // apps
    THEME_LIGHT = 'THEME_LIGHT',
    THEME_DARK = 'THEME_DARK',

    // chains
    MAINNET = 'MAINNET',
    UNICHAIN = 'UNICHAIN',
    BASE = 'BASE',

    // logos
    APP_LOGO_DESKTOP_WINTERCUTE = '/figma/logo/desktop/wintercute.svg',
    APP_LOGO_DESKTOP_TYCHO = '/figma/logo/desktop/market-maker.svg',
    APP_LOGO_MOBILE_WINTERCUTE = '/figma/logo/mobile/wintercute.svg',
    APP_LOGO_MOBILE_TYCHO = '/figma/logo/mobile/market-maker.svg',
    APP_LOGO_DOUBLE_M = '/figma/logo/double-m.svg',

    // protocols
    PROTOCOL_BALANCER = 'PROTOCOL_BALANCER',
    PROTOCOL_CURVE = 'PROTOCOL_CURVE',
    PROTOCOL_PANCAKESWAP = 'PROTOCOL_PANCAKESWAP',
    PROTOCOL_UNISWAP = 'PROTOCOL_UNISWAP',
    PROTOCOL_SUSHISWAP = 'PROTOCOL_SUSHISWAP',

    // icons
    GRID_DROPDOWN = '/figma/dots-grid.svg',
}
